import React from 'react'
import { Form } from 'semantic-ui-react'
import { FilterSchema } from '@adc/blueprint'
import DropdownField from '../../../formFields/dropdownField'
import RadioGroupField from '../../../formFields/radioGroupField'

type SingleSelectProps = FilterSchema.FilterLayoutProps<
  FilterSchema.FilterSingleSelectDefinition,
  FilterSchema.SingleSelectValueType
>

const SingleSelect: React.FunctionComponent<SingleSelectProps> = ({
  definition,
  value,
  elmId,
  onChange,
}) => {
  const options = definition.options.map(option => ({
    key: option.value,
    text: option.label,
    value: option.value,
  }))
  return (
    <Form>
      {definition.styleIntent?.controlVariant === 'inline-radio' ? (
        <RadioGroupField
          name={definition.name}
          label=''
          elmId={`${elmId}_${definition.name}`}
          options={definition.options}
          value={value || ''} // underlying component doesn't like null
          onChange={(
            _e: never, // eslint-disable-line @typescript-eslint/no-unused-vars
            input: { value: FilterSchema.SingleSelectControlValueType }
          ) => {
            onChange(definition.name, input.value || null)
          }}
          hideWrapper
        />
      ) : (
        <DropdownField
          name={definition.name}
          placeholder={definition.placeholder || 'Select'}
          label=''
          elmId={`${elmId}_${definition.name}`}
          options={options}
          value={value}
          onChange={(newValue: FilterSchema.SingleSelectValueType) => {
            onChange(definition.name, newValue)
          }}
          search={false}
          wrapSelection={false}
          fluid
          hideWrapper
        />
      )}
    </Form>
  )
}

export default SingleSelect
